import type { QueryClient } from "@tanstack/react-query";

export const SHOW_ORIGINAL_CONTENT_STORAGE_KEY = "rw_show_original_content";
export const SHOW_TRANSLATED_CONTENT_STORAGE_KEY = "rw_show_translated_content";

export const getShowTranslatedContentFromStorage = (): boolean => {
  try {
    if (typeof window === "undefined") {
      return true;
    }

    const storedValue = window.localStorage.getItem(
      SHOW_TRANSLATED_CONTENT_STORAGE_KEY,
    );
    if (storedValue !== null) {
      return storedValue !== "false";
    }

    const legacyShowOriginal = window.localStorage.getItem(
      SHOW_ORIGINAL_CONTENT_STORAGE_KEY,
    );
    if (legacyShowOriginal !== null) {
      const showTranslated = legacyShowOriginal !== "true";
      setShowTranslatedContentInStorage(showTranslated);
      return showTranslated;
    }

    return true;
  } catch {
    return true;
  }
};

export const setShowTranslatedContentInStorage = (value: boolean): void => {
  try {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(
        SHOW_TRANSLATED_CONTENT_STORAGE_KEY,
        value ? "true" : "false",
      );
    }
  } catch {
    // Storage can be unavailable in restricted browsing contexts.
  }
};

export const getShowOriginalFromStorage = (): boolean =>
  !getShowTranslatedContentFromStorage();

export const setShowOriginalInStorage = (value: boolean): void => {
  setShowTranslatedContentInStorage(!value);
};

const DISPLAY_CONTENT_QUERY_ROOTS = new Set([
  "activities",
  "eventDetail",
  "events",
  "favoritePosts",
  "groupEvents",
  "myEvents",
  "pinnedPosts",
  "postDetail",
  "posts",
  "registeredEvents",
  "studyGroup",
  "studyGroupsByUserId",
  "studyGroupsForFilter",
  "studyGroups",
]);

export const invalidateDisplayContentQueries = (queryClient: QueryClient) => {
  const predicate = (query: { queryKey: readonly unknown[] }) => {
    const root = query.queryKey[0];
    return typeof root === "string" && DISPLAY_CONTENT_QUERY_ROOTS.has(root);
  };

  queryClient.invalidateQueries({ predicate });
  queryClient.refetchQueries({ predicate, type: "active" });
};
